import { Type } from '@angular/core';

import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';


export class CoverageMetricChartDisplaySettingsField implements FormFieldModel {

    property: string;
    fieldComponent: Type<AbstractFormFieldComponent>;
    label: string;
    description: string;

    constructor(
        property: string,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        label?: string,
        description?: string
    ) {
        this.property = property;
        this.fieldComponent = fieldComponent;
        this.label = label;
        this.description = description;
    }
}
